import { Component, OnInit } from '@angular/core';
import { AppConstants } from "../../shared/constants/app-constants";
import { DataManagerService } from "../../data/services/DataManager/data-manager.service";
import { GetStatementsAction } from '../statements/get-statements.action'
import { DatePipe } from '@angular/common';
import { ErrorConstants } from "../../shared/constants/error-constants";
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { StatementsModel } from '../../data/model/StatementsModel/statements.model';
import {ApiResponseModel} from '../../data/model/ApiResponseModel/api-response.model';
import { PAYARC_DATE_FORMATS } from '../../shared/material-date-formats';

@Component({
    selector: 'app-statements',
    templateUrl: './statements.component.html',
    styleUrls: ['./statements.component.css'],
    standalone: false,
    providers: [{
      provide: MAT_DATE_FORMATS,
      useValue: { ...PAYARC_DATE_FORMATS, display: { ...PAYARC_DATE_FORMATS.display, dateInput: { year: 'numeric', month: '2-digit' } } }
    }]
})
export class StatementsComponent extends GetStatementsAction implements OnInit {
  statementlist: ApiResponseModel<StatementsModel>;
  requestFailed = false;
  stamentservice: string;
  from_date: Date = new Date();
  to_date: Date = new Date();

  constructor(
    dataManager: DataManagerService, private datePipe: DatePipe, snackBar: MatSnackBar) {
    super();
    this.snackBar = snackBar;
    this.dataManager = dataManager;
    this.emptyListMsg = ErrorConstants.statementErrorMsg[0];
    this.setDates();
    this.statementlist = new ApiResponseModel();
    this.stamentservice = '/merchant_statements';
    this.getListUrl = AppConstants.BASE_URL + this.stamentservice;
  }

  ngOnInit() {
    this.openAdfReport();
  }

  onFromMonthSelected(normalizedMonth: Date, datepicker: MatDatepicker<Date>) {
    this.from_date = new Date(normalizedMonth.getFullYear(), normalizedMonth.getMonth(), 1);
    this.checkdate();
    datepicker.close();
  }

  onToMonthSelected(normalizedMonth: Date, datepicker: MatDatepicker<Date>) {
    this.to_date = new Date(normalizedMonth.getFullYear(), normalizedMonth.getMonth() + 1, 0);
    this.checkdate2();
    datepicker.close();
  }

  checkdate() {
    if (!this.isNull(this.from_date) && this.from_date.toString() === 'Invalid Date') {
      this.from_date = null;
    }
  }

  checkdate2() {
    if (!this.isNull(this.to_date) && this.to_date.toString() === 'Invalid Date') {
      this.to_date = null;
    }
  }

  openAdfReport(): void {
    if (this.isNull(this.from_date) || this.isNull(this.to_date) || this.from_date > this.to_date) {
      this.showSnackBar('Enter valid date.', 'Ok', 3000);
    } else {
      this.loadFlag = true;
      this.from =  this.datePipe.transform(this.from_date, 'yyyy-MM-dd');
      this.to = this.datePipe.transform(this.to_date, 'yyyy-MM-dd');
      this.setUrl();
    }
  }

  setDates() {
    const today = new Date();
    this.from_date = new Date(today.getFullYear(), 0, 1);
    this.to_date = new Date();
  }

  protected getListRes(response) {
    this.loadFlag = false;
    this.requestFailed = false;
    this.statementlist = response;
    this.metadata = response.meta.pagination;
  }
  protected getListErr(error: any) {
    this.loadFlag = false;
    this.requestFailed = true;
    this.errorMsg = this.networkErrorHandler(error.error, ErrorConstants.statementErrorMsg) || 'Something went wrong.';
  }

  download_statement(id) {
    this._getstatementPdf = AppConstants.BASE_URL + AppConstants.SERVICE_NAME_STATEMENTS + '/' + id
    this.getStatementPdf();
    this.showSnackBar('File is loading.', 'Ok', 3000);
  }
  protected passStatementPdfResponse(res: any) {
    const downloadURL = window.URL.createObjectURL(res);
    const link = document.createElement('a');
    link.href = downloadURL;
    link.download = "statement.pdf";
    link.click();
  }

  protected passStatementPdfError(err: any) {
  }

  view_statement(id) {
    this._getstatementPdfView = AppConstants.BASE_URL + AppConstants.SERVICE_NAME_STATEMENTS + '/' + id
    this.getStatementPdfView();
    this.showSnackBar('File is loading.', 'Ok', 3000);
  }
  protected passStatementPdfViewResponse(res: any) {
    const downloadURL = window.URL.createObjectURL(res);
    const a = document.createElement('a');
    a.href = downloadURL;
    a.setAttribute('target', '_blank');
    a.click();
  }

  protected passStatementPdfViewError(err: any) {
  }

  paginate(paginateExtension) {
    this.getList(paginateExtension);
  }
}
